interface DefaultQuickScanOptions {
  isSubscriber: boolean
  isRescan?: boolean
}

export function getDefaultQuickScan({ isSubscriber }: DefaultQuickScanOptions): boolean {
  return !isSubscriber
}
